module.exports = __webpack_public_path__ + "img/lc.2e9ebc8c.png";